import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { useSelector } from "react-redux";
import { selectClubName, selectSettings } from "../store/slices/settingsSlice";
import { useTheme } from "../context/ThemeContext";
import SEOHead from "../components/seo/SEOHead";
import BreadcrumbSchema from "../components/seo/BreadcrumbSchema";
import LocalBusinessSchema from "../components/seo/LocalBusinessSchema";

const AboutPage = () => {
  const settings: any = useSelector(selectSettings);
  const club = useSelector(selectClubName);
  const { isDarkMode } = useTheme();

  // Only the club's own words. When it has written none, the section shows
  // just its heading: the old stand-in text told every club's visitors it was
  // a gymnastics club "in the heart of York Pennsylvania".
  const aboutUsContent: string = settings?.about_us_full?.trim() || "";

  return (
    <div className={`flex flex-col min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <SEOHead title="About Us" description={`Learn about ${club || "our club"} and our mission.`} />
      <BreadcrumbSchema items={[{ name: "About", path: "/about" }]} />
      <LocalBusinessSchema />
      <Navbar transparent={true} />

      {/* Hero Section */}
      <section className={isDarkMode ? 'bg-gray-900' : 'bg-white'}>
        {/*<div className="container mx-auto px-6 py-8 relative z-10">
          {/* Optional Hero Title or Breadcrumbs
        </div> */}

        {/* Main About Content */}
        <div className={isDarkMode ? 'bg-gray-900' : 'bg-white'}>
          <div className="w-full overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Left: Image or Illustration */}
              <div
                className="text-white p-6 sm:p-8 flex flex-col justify-center"
                style={{ backgroundColor: isDarkMode ? "#4b5563" : "#6b7280" }}
              >
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold mb-4 sm:mb-6 text-white">
                  About {club || "Our Club"}
                </h2>

                {/* About Us Content */}
                <div className="space-y-4 text-sm sm:text-base leading-relaxed">
                  {aboutUsContent
                    ?.split("\n")
                    ?.map((para: string, idx: number) => (
                      <p
                        key={idx}
                        className="text-sm sm:text-base mb-4 leading-relaxed text-white"
                      >
                        {para}
                      </p>
                    ))}
                </div>
              </div>

              {/* Right: Mission, Values, or More Info */}
              <div className={`p-6 sm:p-8 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <h3 className={`text-xl sm:text-2xl lg:text-3xl font-semibold mb-4 sm:mb-6 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  Our Mission
                </h3>
                <p className={`text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  At {club || "GymClub"}, our mission is to create a safe, fun,
                  and inspiring environment where children of all ages can
                  thrive physically and mentally through gymnastics training.
                </p>

                <h4 className={`text-lg sm:text-xl font-semibold mb-3 sm:mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  Core Values
                </h4>
                <ul className={`list-disc list-inside text-sm sm:text-base space-y-2 sm:space-y-3 pl-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  <li className="leading-relaxed">
                    Empowerment through movement
                  </li>
                  <li className="leading-relaxed">Inclusivity and community</li>
                  <li className="leading-relaxed">
                    Positive coaching and encouragement
                  </li>
                  <li className="leading-relaxed">
                    Safety, technique, and fun in every session
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AboutPage;
